export const addAWSUrl = (fileName: string) => {
  if (fileName.includes(process.env.REACT_APP_ASSETS_URL as string)) {
    return fileName;
  }

  return process.env.REACT_APP_ASSETS_URL + '/' + fileName;
};
